import { HelmetDexteel } from "@dexteel/mesf-core";
import { SuppliersManager } from "./components/SuppliersManager";

export const SuppliersPage = () => {
	return (
		<>
			<HelmetDexteel title="Suppliers" />
			<SuppliersManager />
		</>
	);
};
